'use strict';

var App = (function() {

    var $html,
        $body;

    var _sessionId;

    function init( options ) {

        var defaults = {
            stickyFooter: false
        };

        var settings = $.extend({}, defaults, options);

        $html = $(document.documentElement).removeClass('no-js').addClass('js');
        $body = $(document.body);

        this.interfaceName = $body.data('interface-name');

        if ( location.toString().match(/SESS_ID=(\d+)/) ) {
            _sessionId = RegExp.$1;
        }

        if ( settings.stickyFooter ) stickyFooter();

    }

    function showActivity() {
        if ( $.fancybox ) {
            if ( typeof $.fancybox.showActivity === 'function' ) {
                $.fancybox.showActivity(); // v.1
            } else if ( typeof $.fancybox.showLoading === 'function' ) {
                $.fancybox.showLoading();  // v.2
            }
        }
    }

    function hideActivity() {
        if ( $.fancybox ) {
            if ( typeof $.fancybox.hideActivity === 'function' ) {
                $.fancybox.hideActivity(); // v.1
            } else if ( typeof $.fancybox.hideLoading === 'function' ) {
                $.fancybox.hideLoading();  // v.2
            }
        }
    }

    function getCssSize( element, property ) {
        return parseFloat( $(element).css(property).replace('px', '') );
    }

    function getJSON( action, data, handler, options ) {

        if ( _sessionId ) {
            data.SESS_ID = _sessionId;
        }

        var url = '/json/' + action + '/';
        var errorMessage = 'Произошла ошибка при загрузке данных. Попробуйте перезагрузить страницу.';

        var settings = $.extend({
            method:        'POST',
            data:           data,
            dataType:      'json',
            // success:        handler,
            checkStatus:    true,
            showActivity:   true,
            hideError:      true,
        }, options || {});

        settings.success = function( data, textStatus, jqXHR ) {
            if ( !settings.checkStatus || data.status ) {
                if ( typeof handler === 'function' ) {
                    handler(data, textStatus, jqXHR);
                }
            } else {
                alert(errorMessage);
            }
        };

        settings.error = function() {
            if ( !settings.hideError ) {
                alert(errorMessage);
            }
        };

        settings.complete = function() {
            if ( settings.showActivity ) {
                App.hideActivity();
            }
        };

        if ( settings.showActivity ) {
            App.showActivity();
        }

        return $.ajax(url, settings);

    }

    function stickyFooter() {

        var $wrapper = $('.wrapper').eq(0);
        var $footer = $('.footer').eq(0);

        var height = $footer.outerHeight();

        $body.addClass('page--sticky-footer');

        $wrapper.css('padding-bottom', height);

        $footer.css({
            height:     height,
            marginTop: -height
        });

    }

    function elementSupportsAttribute( element, attribute ) {
        var test = document.createElement(element);
        return ( attribute in test );
    }

    return {
        init:               init,
        showActivity:       showActivity,
        hideActivity:       hideActivity,
        getCssSize:         getCssSize,
        getJSON:            getJSON,
        elementSupportsAttribute: elementSupportsAttribute
    };

})();
